function useStyles() {
    return {
        container: {
            height: 'calc(100% - 50px)',
            '& video': {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            },
            '& img': {
                width: '100%',
                objectFit: 'cover'
            },
        }
    }
}

export { useStyles }
